import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from '../../../src/styles/colors';
import {
  ZeeFontBold,
  ZeeFontMedium,
  getInitialLoadIcons,
  ZeeFontRegular
} from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
import { flex } from '../../styles/utils';
import { InitialLoadIconsSet } from '../../utils/constants/IconsConstants';

export const MainContainer = styled.div<{ positionDownwards: boolean }>`
  ${flex('column', '', '')};
  width: 100%;
  position: absolute;
  ${(props) => (props.positionDownwards ? 'bottom: 100%;' : 'top: 100%;')}
  border-radius: 6px;
  padding: 4px 4px 12px 4px;

  background: ${colors.SearchCardBg};
  overflow-y: auto;
  max-height: 152px;
  z-index: 1;
  cursor: pointer;
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: ${colors.SearchCardBg};
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.PurpleLight};
    border-radius: 8px;
    padding-left: 4px;
    height: 74px;
  }

  ${MQ.MediaLg} {
    padding: 4px 4px 16px 4px;
    max-height: 200px;
  }
`;

export const SpanTag = styled.span<{ isSelected: boolean }>`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontMedium(14, 20)};
  background: ${({ isSelected }) =>
    !isSelected ? colors.SearchCardBg : colors.PurpleLight};
  height: 36px;
  border-radius: 4px;
  align-items: flex-start;
  padding: 8px 12px;
  ${MQ.MediaLg} {
    padding: 12px 16px;
    height: 48px;
    ${ZeeFontRegular(16, 24)};
  }
  &:hover {
    background: ${colors.PurpleLight};
    color: ${colors.GrayC4};
  }
`;

export const ChevronDown = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.RIGHT_CHEVRON)};
  transform: rotate(-90deg);
  transition: 0.2s;
  margin-left: 5px;
`;

export const ChevronUp = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.RIGHT_CHEVRON)};
  transform: rotate(90deg);
  transition: 0.2s;
  margin-left: 5px;
`;

export const DropDownMainContainer = styled.div<{ page: string }>`
  position: relative;
  margin: 20px 0 66px 0;
  padding-left: 16px;
  ${(props) => (props.page = 'consumption' && 'margin: 0; padding: 0 0 0;')};
  ${MQ.MediaMd} {
    padding-left: 32px;
    ${(props) => (props.page = 'consumption' && 'padding: 0 0 0')};
  }
`;

const fieldContainer = css`
  background: transparent;
  border: 1px solid ${colors.PrimaryWhiteColor};
  border-radius: 6px;
  color: ${colors.PrimaryWhiteColor};
  padding: 8px 10px 8px 16px;
  margin: 8px 0;
  height: 38px;
  min-width: 212px;
  ${flex('row', 'flex-start')}
  ${MQ.MediaLg} {
    min-width: 239px;
    height: 48px;
    padding: 12px 12px 12px 18px;
  }
  ${MQ.MediaXl} {
    min-width: 257px;
  }
`;
export const FieldContainer = styled.div`
  ${fieldContainer}
`;
export const menuTitle = css`
  ${ZeeFontBold(14, 20)};
  color: ${colors.PrimaryWhiteColor};
  width: 100%;
  cursor: pointer;
  ${flex('row', 'space-between', 'center')};
  ${MQ.MediaLg} {
    ${ZeeFontBold(16, 22)};
  }
`;
